var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Instructions',{attrs:{"ctaLabel":_vm.label,"icon":"photo-video","title":_vm.$t('empty-album-title'),"description":_vm.description},on:{"click":function($event){return _vm.$emit('upload')}}})}
var staticRenderFns = []

export { render, staticRenderFns }